module.exports = __webpack_public_path__ + "logo72.png?65b0eb086a4d618112d0dc2294f8003d";